module.exports = __webpack_public_path__ + "static/media/clock-image.59bf414f.svg";